import { Temporal } from "temporal-polyfill";

const withOrdinalSuffix = (day: number) => {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};

export const getCurrentMonthAndLastDay = () => {
  const today = Temporal.Now.plainDateISO();
  const currentMonth = today.toLocaleString("en-US", { month: "long" });
  const lastMonth = today.subtract({ months: 1 }).toLocaleString("en-US", { month: "long" });
  const lastDayOfMonth = today.with({ day: today.daysInMonth }).day;
  return {
    currentMonth,
    lastMonth,
    lastDayOfMonth,
    lastDayOfMonthSuffixed: withOrdinalSuffix(lastDayOfMonth),
  };
};

export const PayoutAlertBanner = () => {
  const { currentMonth, lastMonth, lastDayOfMonthSuffixed } = getCurrentMonthAndLastDay();

  return (
    <div class="py-10px px-24px bg-[#E9F7FF] flex gap-12px items-center env-mobile:px-16px">
      <i class="inline-block i-bp-info size-16px text-black flex-shrink-0" />
      <div class="prose-xs-b text-primary">
        Your earnings from {lastMonth} are now available for payout. Request your withdrawal by {currentMonth}{" "}
        {lastDayOfMonthSuffixed}
        (PST), or your balance will roll over to the next month.
      </div>
    </div>
  );
};
